export default __webpack_public_path__ + "static/media/DtVkJx26TKEr37c9aBBxUl0c5ijTjQJElti5.f0300e3b.woff2";